module.exports = __webpack_public_path__ + "img/fincor_lion.8a18214f.png";